import {StepSection} from '../StepSection'
import {ItemCreationForm, ServiceFields} from '../../../../../model/NewItemInput'
import {TextField} from '@mui/material'
import {getIn, useFormikContext} from 'formik'
import {Label} from '../../../../../../genericComponents/typographie/Label'

export const CommentsSection = () => {
    const formik = useFormikContext<ItemCreationForm>()
    return <StepSection title="Comments">
        <div className="service-form-section">
            <Label htmlFor={ServiceFields.Comments}>
                Please enter any additional information, specific requirements, or remarks regarding this
                item.
            </Label>
            <TextField
                fullWidth multiline name={ServiceFields.Comments}
                id={ServiceFields.Comments}
                rows={2}
                placeholder="Type here"
                value={getIn(formik.values, ServiceFields.Comments)}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={getIn(formik.touched, ServiceFields.Comments) && Boolean(getIn(formik.errors, ServiceFields.Comments))}
                inputProps={{'data-cy': 'description-form'}}
            />
        </div>
    </StepSection>
}